import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DeviceService, HttpService, ScreenSize } from 'vas-mobile-api';

import { Reports } from '../models/report';
import { DataExchangeService } from '../services/dataexchange.service';

@Component({
  selector: 'app-reports-list',
  templateUrl: './reports-list.component.html',
  styleUrls: ['./reports-list.component.css']
})
export class ReportsListComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void> = new Subject();
  public showMobile: boolean;
  public viewMode = 'ltr';

  public config: Reports;

  constructor(
    private deviceService: DeviceService,
    private httpService: HttpService,
    private router: Router,
    private des: DataExchangeService,
  ) { }



  ngOnInit() {
    this.httpService.getLocalResource('assets/config/reportsConfig.json').subscribe((config) => {
      this.config = config;
    });

    this.des.changeTitelBarName('VASTREE_DMTN4');
    this.deviceService.size.pipe(takeUntil(this.ngUnsubscribe)).subscribe((size) => {
      this.showMobile = size <= ScreenSize.sm;
    });

    this.des.viewModeChange$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(mode => {
      this.viewMode = mode;
    });

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public navigate(id: string) {
    this.router.navigate(['reportDetail', id]);
  }

}
